/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

import {GetterTree} from 'vuex';
import {RootState} from '@/store/types';
import {UserDetailsInterface, UserSessionStateInterface} from '@/store/modules/user-session/types';

/**
 * The user session module getters.ts provide entry points for stored data.
 *
 * @author Jonny Cook <jcook@frontier.co.uk>
 */

export const getters: GetterTree<UserSessionStateInterface, RootState> = {
    /**
     * Gets the session verifier.
     *
     * @param {UserSessionStateInterface} state
     *
     * @returns {string}
     */
    verifier(state: UserSessionStateInterface): string {
        if (undefined === state.session.verifier || '' === state.session.verifier) {
            return '';
        }
        return state.session.verifier;
    },

    /**
     * Gets the refresh token.
     *
     * @param {UserSessionStateInterface} state
     *
     * @returns {string}
     */
    refreshToken(state: UserSessionStateInterface): string {
        if (undefined === state.session.refresh || '' === state.session.refresh) {
            return '';
        }
        return state.session.refresh;
    },

    /**
     * Gets the session token.
     *
     * @param {UserSessionStateInterface} state
     *
     * @returns {string}
     */
    token(state: UserSessionStateInterface): string|boolean {
        if (undefined === state.session.token || '' === state.session.token) {
            return false;
        }
        return state.session.token;
    },

    /**
     * Authentication checker.
     *
     * @param {UserSessionStateInterface} state
     *
     * @returns {boolean}
     */
    authenticated(state: UserSessionStateInterface): boolean {
        return '' !== state.session.token && state.session.expiry > (new Date().getDate());
    },

    /**
     * Get the user details.
     *
     * @param {UserSessionStateInterface} state
     *
     * @returns {UserDetailsInterface | undefined}
     */
    getUserDetails(state: UserSessionStateInterface): UserDetailsInterface | undefined {
        return state.userDetails;
    },

    /**
     * Get the current view.
     *
     * @param {UserSessionStateInterface} state
     *
     * @returns {{name: string, param?: any} | undefined}
     */
    getCurrentView(state: UserSessionStateInterface): {name: string, param?: any} | undefined {
        return state.currentView;
    },

};
